/* eslint-disable */
export default {
  eula: '最终用户许可协议',
  eulaAbbr: '最终用户许可协议',
} as const;

// @key: @#@"eula"@#@ @source: @#@"End User License Agreement"@#@
// @key: @#@"eulaAbbr"@#@ @source: @#@"EULA"@#@
